import React, { useState } from 'react';
import { NivelEscopo } from '../models/scope';
import { useMaestroContext } from '../context/MaestroContext';
import ModalCriarEscopo from './ModalCriarEscopo';

const SeletorEscopo: React.FC = () => {
  const { escopo, setEscopo, grupoEconomico, gruposEmpresas, empresas } = useMaestroContext();
  const [criandoEscopo, setCriandoEscopo] = useState(false);

  const mudarNivel = (nivel: NivelEscopo) => {
    if (nivel === 'GRUPO_ECONOMICO') setEscopo({ nivel, grupoEconomicoId: grupoEconomico.id });
    else if (nivel === 'GRUPO_EMPRESAS') setEscopo({ nivel, grupoEconomicoId: grupoEconomico.id, grupoEmpresasId: gruposEmpresas[0]?.id });
    else setEscopo({ nivel, grupoEconomicoId: grupoEconomico.id, empresaId: empresas[0]?.id });
  };

  return (
    <div className='mc-seletor-escopo'>
      <div className='mc-seletor-escopo__niveis'>
        <button type='button' className={escopo.nivel === 'GRUPO_ECONOMICO' ? 'is-active' : ''} onClick={() => mudarNivel('GRUPO_ECONOMICO')}>
          <i className='bi bi-diagram-3' /> Grupo Econômico
        </button>
        <button type='button' className={escopo.nivel === 'GRUPO_EMPRESAS' ? 'is-active' : ''} onClick={() => mudarNivel('GRUPO_EMPRESAS')}>
          <i className='bi bi-collection' /> Grupo de Empresas
        </button>
        <button type='button' className={escopo.nivel === 'EMPRESA' ? 'is-active' : ''} onClick={() => mudarNivel('EMPRESA')}>
          <i className='bi bi-building' /> Empresa
        </button>
      </div>

      <div className='mc-seletor-escopo__detalhe'>
        <i className='bi bi-check2-circle' />
        {escopo.nivel === 'GRUPO_ECONOMICO' && <span className='mc-seletor-escopo__resumo'>{grupoEconomico.nome} · {empresas.length} empresa(s)</span>}

        {escopo.nivel === 'GRUPO_EMPRESAS' && (
          <select value={escopo.grupoEmpresasId ?? ''} onChange={e => setEscopo({ ...escopo, grupoEmpresasId: Number(e.target.value) })}>
            {gruposEmpresas.map(g => <option key={g.id} value={g.id}>{g.nome}</option>)}
          </select>
        )}

        {escopo.nivel === 'EMPRESA' && (
          <select value={escopo.empresaId ?? ''} onChange={e => setEscopo({ ...escopo, empresaId: Number(e.target.value) })}>
            {empresas.map(emp => <option key={emp.id} value={emp.id}>{emp.nome}</option>)}
          </select>
        )}

        <button type='button' className='mc-btn mc-btn--secondary mc-btn--sm' title='Cadastrar novo grupo econômico ou grupo de empresas' onClick={() => setCriandoEscopo(true)}>
          <i className='bi bi-plus-lg' /> Novo
        </button>
      </div>
      <ModalCriarEscopo aberto={criandoEscopo} onFechar={() => setCriandoEscopo(false)} />
    </div>
  );
};

export default SeletorEscopo;
